export default __webpack_public_path__ + "static/media/banner_girl_2.287dc3e4.png";